import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { Star } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const INITIAL_COUNT = 3;

export function ReviewsCard({
  reviews = [],
  rating,
}: {
  reviews?: any[];
  rating?: {
    count: number;
    rating: number;
    fmt_rating: string;
  };
}) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const initialReviews = reviews.slice(0, INITIAL_COUNT);
  const remainingReviews = reviews.slice(INITIAL_COUNT);
  const hasMore = reviews.length > INITIAL_COUNT;
  console.log(reviews);

  const renderReview = (r: any) => (
    <article
      key={r.id}
      // aria-label={t('reviews.aria_label_by_author', { author: r.author })}
      className="flex gap-4"
    >
      <Avatar>
        {/*<AvatarImage src={r.avatar} alt={t('reviews.avatar_alt', { author: r.author })} />*/}
        {/*<AvatarFallback>{r.author.charAt(0)}</AvatarFallback>*/}
      </Avatar>
      <div className="flex-1">
        <div className="flex items-center justify-between">
          {/*<div className="font-medium">{r.author}</div>*/}
          <div className="text-sm text-muted-foreground">{r.timeAgo}</div>
        </div>
        <div
          className="flex items-center gap-1 text-sm text-amber-500"
          aria-hidden
        >
          {Array.from({ length: Math.round(r.rating || 0) }).map((_, i) => (
            <Star key={i} className="h-4 w-4" />
          ))}
        </div>
        <p className="mt-1 text-sm text-muted-foreground">{r.comment}</p>
      </div>
    </article>
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('reviews.title')}</CardTitle>
        <CardDescription className="text-right">
          {rating ? t('reviews.rating_out_of_five', { rating: rating.fmt_rating }) : '—'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {initialReviews.map(renderReview)}

          {hasMore && (
            <Collapsible open={expanded} onOpenChange={setExpanded}>
              <CollapsibleContent className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                <div className="space-y-6 pt-6">
                  {remainingReviews.map(renderReview)}
                </div>
              </CollapsibleContent>
              <CollapsibleTrigger asChild>
                <button
                  type="button"
                  className="mt-6 w-full text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  {expanded
                    ? t('reviews.show_fewer')
                    : t('reviews.show_all_reviews_count', { count: reviews.length })}
                </button>
              </CollapsibleTrigger>
            </Collapsible>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
